import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewDensityWideIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="viewDensityWide" ref={ref} {...props}>
    <path d="M3.3,3a.755.755,0,0,1,.75-.75h16a.75.75,0,0,1,0,1.5h-16A.749.749,0,0,1,3.3,3Zm-.05,13.45V7.7a2.452,2.452,0,0,1,2.44-2.45H18A2.762,2.762,0,0,1,20.752,8v8.45A2.453,2.453,0,0,1,18.3,18.9H5.692A2.451,2.451,0,0,1,3.252,16.447Zm1.5,0a.941.941,0,0,0,.94.95H18.3a.95.95,0,0,0,.95-.95V8A1.25,1.25,0,0,0,18,6.747H5.692a.947.947,0,0,0-.94.95Zm15.3,3.8h-16a.75.75,0,1,0,0,1.5h16a.75.75,0,0,0,0-1.5Z" />
  </Icon>
)) as IconWithRender;

ViewDensityWideIcon.displayName = 'ViewDensityWideIcon';
ViewDensityWideIcon.renderIcon = (props) => <ViewDensityWideIcon {...props} />;
export default ViewDensityWideIcon;
